import moment, { Moment, MomentInput } from 'moment';

export class DateTimeHelper {
  static readonly DATE_FORMAT = 'YYYY-MM-DD';
  static readonly DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  static readonly DATE_TIME_MINUTES_FORMAT = 'YYYY-MM-DD HH:mm';
  static readonly MONTH_FORMAT = 'YYYY-MM';

  static formatDate(value?: MomentInput, useUtc = false) {
    return this.format(value, this.DATE_FORMAT, useUtc);
  }

  static formatDateTime(value?: MomentInput, useUtc = false) {
    return this.format(value, this.DATE_TIME_FORMAT, useUtc);
  }

  static formatDateTimeMinutes(value?: MomentInput, useUtc = false) {
    return this.format(value, this.DATE_TIME_MINUTES_FORMAT, useUtc);
  }

  static formatMonth(value?: MomentInput, useUtc = false) {
    return this.format(value, this.MONTH_FORMAT, useUtc);
  }

  static parseDate(value?: string, useUtc = true) {
    if (!value) return undefined;
    const parsed = useUtc
      ? moment.utc(value, this.DATE_FORMAT, true)
      : moment(value, this.DATE_FORMAT, true);
    return parsed.isValid() ? parsed.toDate() : undefined;
  }

  private static format(value: MomentInput, format: string, useUtc: boolean) {
    if (value === undefined || value === null || value === '') return '';
    const parsed: Moment = useUtc ? moment.utc(value) : moment(value);
    return parsed.isValid() ? parsed.format(format) : '';
  }
}
